export class groups {
    public id: number;
    public nombre: string;
}